<template>
  <div class="mobile_container">
    <div class="mobile_banner" @click="console">
      <div class="shade">
        <p>当前数据（{{currentTime}}）</p>
        <p>
          {{CurrentValue}}
          <span>{{Unit}}</span>
        </p>
        <p>
          设备编号：{{DeviceId}}
        </p>
      </div>
    </div>
    <!--<ul class="title">-->
    <!--<li class="fl">蔬菜大棚左上角PH1:</li>-->
    <!--<li class="fr">-->
    <!--<span>5.51</span>-->
    <!--<span>ph</span>-->
    <!--</li>-->
    <!--</ul>-->

    <div class="chart">
      <ul class="title">
        <li class="historyDataTitle fl">历史数据</li>
        <li class="fr">
          <span v-if="showDateBox" class="date" @click="openPicker1">
            <span class="val">{{dateValueStartFormat}}</span>
            <img src="../../assets/img/dateBox.png" alt="">
          </span>
          <span v-if="showDateBox" class="date" @click="openPicker2">
            <span class="val">{{dateValueEndFormat}}</span>
            <img src="../../assets/img/dateBox.png" alt="">
          </span>
          <span v-if="!showDateBox" @click="openPicker1"><i class="icon iconfont1 icon1-kaishishijian"></i></span>
          <span v-if="!showDateBox" @click="openPicker2"><i class="icon iconfont1 icon1-jieshushijian"></i></span>
          <mt-datetime-picker
            ref="picker1"
            type="date"
            v-model="dateValueStart"
            :startDate="startDate"
            @confirm="dateConfirmStart"
            year-format="{value} 年"
            month-format="{value} 月"
            date-format="{value} 日">
          </mt-datetime-picker>

          <mt-datetime-picker
            ref="picker2"
            type="date"
            v-model="dateValueEnd"
            :endDate="endDate"
            @confirm="dateConfirmEnd"
            year-format="{value} 年"
            month-format="{value} 月"
            date-format="{value} 日">
          </mt-datetime-picker>
        </li>
      </ul>
      <div class="echarts_area mt20">
        <Spin class="loadingArea" v-if="loading">
          <Icon type="ios-loading" size=18 class="demo-spin-icon-load icon-load"></Icon>
          <div>Loading</div>
        </Spin>
        <li v-if="noHistoryData" style="text-align: center;border: none">
          <img src="../../assets/img/m/noHistoryChart.png" alt="" style="width: 3rem;margin-top: 0.6rem">
          <p style="margin-top: 0.20rem;color: rgba(0,0,0,0.2);font-size: 0.24rem">暂无数据</p>
        </li>
        <div id="myChart"></div>
      </div>
      <ul class="bottom">
        <li :class="{active: chartDayActive}" @click="getDrawData(1)">近1天</li>
        <li :class="{active: chartWeekActive}" @click="getDrawData(7)">近7天</li>
        <li :class="{active: chartMonthActive}" @click="getDrawData(30)">近30天</li>
      </ul>
    </div>
  </div>
</template>

<script>
  import config from '@/config.js'
  import lib from "@/assets/js/lib/index.js"
  import '@/assets/css/icon-iot-mobile/iconfont.css'//iconfont1

  export default {
    name: 'sensorHistory',
    components: {},
    data() {
      return {
        baseUrl: config("baseServerUrl", "."),
        showDateBox: false,
        dateValueStartFormat: '',
        dateValueEndFormat: '',
        loading: false,
        noHistoryData: false,
        Id: "",
        Unit: "",
        DeviceId: "",
        CurrentValue: "",
        currentTime: "",
        chartDayActive: true,
        chartWeekActive: false,
        chartMonthActive: false,
        curSensor: {},
        startDate: new Date(),
        endDate: new Date(),
        dateValueStart: new Date(),
        dateValueEnd: new Date(),
      }
    },
    created: function () {
      this.Id = this.$route.query.Id
      this.CurrentValue = this.$route.query.CurrentValue

      var token = this.$route.query.token
      var username = this.$route.query.username

      if (lib.isset(token) && lib.isset(username) && token.length > 0 && username.length > 0) {
        this.$store.dispatch('UserLogin', token)
        this.$store.dispatch('UserName', username)
      }


      this.currentTime = lib.date('Y-m-d H:i', new Date().getTime() / 1000)
      //获取设备
      let url = this.baseUrl + 'api/devicesensor/getbyid?id=' + this.Id
      this.$http.get(url, {}).then(res => {
        if (res.data.StatusCode == 200) {
          var data = lib.isset(res.data.Data) ? res.data.Data || [] : []
          console.log(data)
          this.DeviceId = data.DeviceId
          this.Unit = data.Unit
        } else {
          this.$Message.error(res.data.Error)
        }
      }).catch(response => {
        this.$Message.error(response.message);
      })
      this.getDrawData()

      //用于显示banner当前时间
      var _this = this
      setInterval(function () {
        _this.currentTime = lib.date('Y-m-d H:i', new Date().getTime() / 1000)
      }, 60000)//60秒更新

      //初始化日期插件时间
      var startDateDefault = lib.date('Y-m-d',lib.strtotime('-1 week'))
      this.startDate = new Date('2018-01-01')
      this.endDate = new Date()
      this.dateValueStart = new Date(startDateDefault)
      this.dateValueEnd = new Date()
    },
    watch: {
      dateValueEnd: function (n, o) {
        console.log('n', n)
      },

    },
    mounted: function () {
      setTitle("设备数据")
    },
    methods: {
      console() {
      },
      openPicker1() {
        this.$refs.picker1.open()
      },
      openPicker2() {
        this.$refs.picker2.open()
      },
      dateConfirmStart() {
        this.showDateBox = true
        var dateStr0 = lib.date('Y-m-d',this.dateValueStart.getTime()/1000)
        var dateStr2 = lib.date('Y-m-d',this.dateValueEnd.getTime()/1000)

        //console.log('this.dateValueEnd - this.dateValueStart',this.dateValueEnd - this.dateValueStart)
        if((this.dateValueEnd - this.dateValueStart) > 0 && (this.dateValueEnd - this.dateValueStart) <= 31*24*60*60*1000) {
          this.dateValueStartFormat = lib.date('Y-m-d',this.dateValueStart)
          this.dateValueEndFormat = lib.date('Y-m-d',this.dateValueEnd)
          this.getDrawData(0)
        }else{
          //选择开始时间时已经超过一个月，默认结束时间为开始时间加一个月的时间
          this.dateValueEnd = new Date(new Date(this.dateValueStart).getTime() + 3600*24*31*1000)
          this.dateValueStartFormat = lib.date('Y-m-d',this.dateValueStart)
          this.dateValueEndFormat = lib.date('Y-m-d',this.dateValueEnd)
          this.getDrawData(0)
        }
      },
      dateConfirmEnd() {
        this.showDateBox = true
        if((this.dateValueEnd - this.dateValueStart) >= 0 && (this.dateValueEnd - this.dateValueStart) <= 31*24*60*60*1000) {
          this.dateValueStartFormat = lib.date('Y-m-d',this.dateValueStart)
          this.dateValueEndFormat = lib.date('Y-m-d',this.dateValueEnd)
          this.getDrawData(0)
        }else{
          if((this.dateValueEnd - this.dateValueStart) < 0) {
            this.$Message.info('结束时间不能小于开始时间')
          }else{
            this.$Message.info('选择日期范围不能超过一个月')
          }
        }
      },
      getDrawData(type) {
        /*
        type 几种情况
        不传：代表今天
        传值7：近一周
        传值30：近一个月
        传值0：自定义范围
         */
        var _this = this
        this.$http.get(this.baseUrl + 'api/getcurrenttime', {}).then(res => {
          var time = res.data
          this.nowTime = new Date(time).getTime()
          getData()
        }).catch(response => {
          this.$Message.error(response.message);
        })

        function getData() {
          _this.echartNoDataMsg = '暂无数据'
          let sourceData = []
          let StartTime
          let startTimestamp
          let endTimestamp
          let EndTime
          let dayLong = 24 * 3600 * 1000
          if (type == 30) {
            _this.chartDayActive = false
            _this.chartWeekActive = false
            _this.chartMonthActive = true
            startTimestamp = (_this.nowTime - 30 * dayLong) / 1000
            StartTime = lib.date('Y-m-d H:i:s', startTimestamp)
            endTimestamp = _this.nowTime / 1000
            EndTime = lib.date('Y-m-d H:i:s', endTimestamp)
          } else if (type == 7) {
            _this.chartDayActive = false
            _this.chartWeekActive = true
            _this.chartMonthActive = false
            startTimestamp = (_this.nowTime - 7 * dayLong) / 1000
            StartTime = lib.date('Y-m-d H:i:s', startTimestamp)
            endTimestamp = _this.nowTime / 1000
            EndTime = lib.date('Y-m-d H:i:s', endTimestamp)
          } else if (type == 0) { //自定义时间范围
            _this.chartDayActive = false
            _this.chartWeekActive = false
            _this.chartMonthActive = false

            startTimestamp = _this.dateValueStart / 1000
            StartTime = lib.date('Y-m-d H:i:s', startTimestamp)
            endTimestamp = _this.dateValueEnd / 1000
            EndTime = lib.date('Y-m-d H:i:s', endTimestamp)
          } else {//默认显示今天
            _this.chartDayActive = true
            _this.chartWeekActive = false
            _this.chartMonthActive = false
            startTimestamp = (_this.nowTime - 1 * dayLong) / 1000
            StartTime = lib.date('Y-m-d H:i:s', startTimestamp)
            endTimestamp = _this.nowTime / 1000
            EndTime = lib.date('Y-m-d H:i:s', endTimestamp)
          }

          _this.dateValueStartFormat = lib.date('Y-m-d',startTimestamp)
          _this.dateValueEndFormat = lib.date('Y-m-d',endTimestamp)

          _this.loading = true
          _this.noHistoryData = false
          let url = _this.baseUrl + 'api/devicesensor/gethistory'
          _this.$http.post(url, {
            // "Id": _this.curSensor.Id,
            "Id": _this.Id,
//					"StartTime": "2018-05-02T06:58:59.564Z",
//					"EndTime": "2018-05-09T06:58:59.564Z",
            "StartTime": StartTime,
            "EndTime": EndTime,
            "Parms": "",
            "Limit": 0
          }).then(res => {
            _this.loading = false
            if(res.data.Data)
            sourceData = res.data.Data ? res.data.Data.Datas || [] : []
            if (sourceData.length == 0) {
            }
            //数据处理，求每日平局值
            let data = []
            for (var i = 0, len = sourceData.length; i < len; i++) {
              data[data.length] = {
                value: [
                  //lib.str_replace(['2018-','2017-'],'',sourceData[i].At),//x轴 时间
                  sourceData[i].At,
                  sourceData[i].Value
                ]
              }
            }

            if(data.length <= 0) _this.noHistoryData = true
            _this.drawLine(data, type)
          }).catch(error => {
            //_this.loading = false,
            console.log('error',error)
            _this.echartNoDataMsg = '加载错误'
            console.log('查询传感器历史数据失败')
//					_this.$Message.error('查询传感器历史数据失败')
          })
        }

      },
      drawLine(data, type) {
        var interval
        var dataLen = data.length
        if (type == 7 || type == 30 || type == 0) {//间隔显示1天
          interval = 3600 * 24 * 1000
        } else {
          interval = 3600 * 1000
        }

        if (this.curSensor.CurrentValue == -99999) {
          this.curSensor.Unit == ''
        }
        let myChart = this.$echarts.init(document.getElementById('myChart'))
        let option = {
          tooltip: {
            show: true,
            trigger: 'axis',
//						formatter: function(params) {
//							console.log('params',params)
//							if(type == 30) {
//								return lib.str_replace(['2018-','2017-',params[0].data.value[0]]) + params[0].data.value[1]
//							}else if(type == 7) {
//								return lib.str_replace(['2018-','2017-',params[0].data.value[0]]) + params[0].data.value[1]
//							}else {
//								return lib.str_replace(['2018-','2017-',params[0].data.value[0]]) + params[0].data.value[1]
//							}
//						}
          },
          title: {
            // text: dataLen ? '单位：' + this.curSensor.Unit : '',
            text: dataLen ? '单位：' + this.Unit : '',
            textStyle: {
//							color: 'rgba(0, 0, 0, 0.647058823529412)',
              color: 'black',
              fontSize: 12
            },
            left: '3%',
            top: '-2%',
          },
          grid: {
            show: false,
            top: 45,
            bottom: 80,
            left: 35,
            // width: '100%',
            width: 'auto',
            height: 'auto',
          },
          xAxis: {
            type: 'time',
            axisLine: {
              show: false
            },
            axisTick: {
              show: true,
              lineStyle: {
                color: '#ccc',
              }
            },
            min: 'dataMin',
            max: 'dataMax',
            interval: interval,
            axisLabel: {
              show: true,
              rotate: 50,
              formatter: function (value, index) {
                if (type == 30) {
                  let patrn = /^[0-9]*[02468]$/
                  if (patrn.test(index)) {
                    return lib.date('m-d', value / 1000)
                  }
                } else if (type == 7) {
                  return lib.date('m-d', value / 1000)
                } else if (type == 0) {
                  // let patrn = /^[0-9]*[0]$/
                  // if (patrn.test(index)) {
                  //   return lib.date('m-d', value / 1000)
                  // }
                  return lib.date('m-d', value / 1000)
                } else {
                  return lib.date('H:i', value / 1000)
                }
              },
              textStyle: {
                color: 'black',
                fontSize: '10'
              }
            }
          },
          yAxis: {
            type: 'value',
//						name: this.curSensor.Unit,
//						nameTextStyle: {
//							color: 'white',
//						},
            axisLine: {
              show: false
            },
            axisTick: {
              show: true,
              lineStyle: {
                color: '#ccc',
              }
            },
            splitLine: {
              lineStyle: {
                color: '#ccc',
                type: 'dashed'
              }
            },
            axisLabel: {
              show: true,
              rotate: 30,
              formatter: function (value, index) {
                if (value >= 10000 && value < 10000000) {
                  value = value / 10000 + "万";
                } else if (value >= 10000000) {
                  value = value / 10000000 + "千万";
                }
                return value;
              },
              textStyle: {
                color: 'black',
                fontSize: '10'
              }
            }
          },
          series: [{
            name: '',
            type: 'line',
            showSymbol: false,
            hoverAnimation: false,
            lineStyle: {
              color: '#DC9E3B',
              width: 3,
            },
            areaStyle: {
              color: '#FDDD9B'
            },
            smooth: true,
            data: data
          }]
        }
        myChart.clear()
        myChart.setOption(option)
      },
    }
  }
</script>

<style lang="less" scoped>
  /*css部分*/
  .icon-load {
    animation: myMove1 1s infinite;
  }

  @keyframes myMove1 {
    from {
      transform: rotate(40deg);
    }
    to {
      transform: rotate(400deg);
    }
  }

  /*less部分*/
  .mobile_container {
    .mobile_banner {
      width: 100%;
      height: 4.24rem;
      background: url("../../assets/img/m/sensorBack.png");
      background-size: 100% 100%;
      .shade {
        width: 100%;
        height: 4.24rem;
        position: absolute;
        top: 0;
        /*background: rgba(17, 36, 66, 0.87843137254902);*/
        background: linear-gradient(45deg, rgba(104, 32, 204, 0.87843137254902) 0%, rgba(104, 32, 204, 0.87843137254902) 0%, rgba(0, 197, 204, 0.87843137254902) 100%, rgba(0, 197, 204, 0.87843137254902) 100%);
        p {
          margin-top: 0.76rem;
          font-family: '微软雅黑';
          font-weight: 400;
          font-style: normal;
          font-size: 0.26rem;
          color: rgba(255, 255, 255, 0.647058823529412);
          text-align: center;
          &:nth-child(2) {
            margin-top: 0.14rem;
            font-size: 0.72rem;
            color: white;
            span {
              position: relative;
              top: -0.4rem;
              right: 0.1rem;
              font-size: 0.2rem;
            }
          }
          &:nth-child(3) {
            margin-top: 0.14rem;
          }
        }
      }
      img.backimg {
        position: absolute;
        z-index: 2;
        top: 0.28rem;
        right: 0.36rem;
        width: 0.5rem;
      }
    }

    ul.title {
      background: #f4f5f9;
      padding: 0.2rem 0.2rem;
      overflow: hidden;
    }

    div.chart {
      ul.title {
        li.historyDataTitle {
          padding: 12px 0;
        }
        li.fr {
          .date {
            position: relative;
            top: .1rem;
            .val {
              position: absolute;
              &:nth-child(1) {
                top: -.25rem;
                left: .2rem;
              }
            }
            img {
              width: 2.18rem;
              height: .6rem;
            }
          }
        }
        span {
          &:nth-child(1) {
            margin-right: 6px;
          }
          i {
            font-size: 25px;
            color: #2b85e4;
          }
        }
      }
      div.echarts_area {
        position: relative;
        .loadingArea {
          position: absolute;
          top: 2rem;
          left: 45%;
        }
        #myChart {
          width: 100%;
          height: 6rem;
        }
      }
      ul.bottom {
        width: 100%;
        position: fixed;
        bottom: 0;
        left: 0;
        overflow: hidden;
        background: white;
        li {
          width: 33.3%;
          float: left;
          text-align: center;
          background: white;
          border: 1px solid #ebebeb;
          height: .8rem;
          line-height: .8rem;
          &.active {
            background: #26A2FF;
          }
        }
      }
    }

  }
</style>



// WEBPACK FOOTER //
// src/components/mobile/sensorHistory.vue